import { render } from "./Loading.vue?vue&type=template&id=2599dbe0&scoped=true&bindings={}"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=2599dbe0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2599dbe0"

export default script